module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1012-0800cc5e1988c073f845b5e121fe92c4.png";